<template>
  <div class="rtl">
    <m-form
      title="کد تخفیف"
      :isEditing.sync="isEditing"
      :showListBtn="true"
      :showList="false"
      :listRoute="{ name: 'DiscountCodesList' }"
      @submit="submit"
      @delete="deleteItem"
      @clearForm="clearForm()"
    >
      <template #default>
        <v-row>
          <v-col cols="12" md="4">
            <v-text-field label="* کد" v-model="item.code" :disabled="!isEditing" class="rounded-lg" />
          </v-col>
          <v-col cols="12" md="4">
            <v-text-field
              class="rounded-lg"
              label="* درصد تخفیف"
              v-model="item.discount_percentage"
              type="number"
              :disabled="!isEditing"
            />
          </v-col>

          <v-col cols="12" md="4">
            <money label="* حداکثر مبلغ تخفیف (ریال)" v-model="item.max_discount_amount" :disabled="!isEditing" />
          </v-col>

          <v-col cols="12" md="4">
            <money label="حداکثر تعداد استفاده" v-model="item.usage_limit" :disabled="!isEditing" :clearable="true" />
          </v-col>

          <v-col cols="12" md="4">
            <date label="تاریخ شروع" v-model="item.start_at" :disabled="!isEditing" :default="false" :clearable="true" type="datetime" />
          </v-col>
          <v-col cols="12" md="4">
            <date label="تاریخ پایان" v-model="item.expire_at" :disabled="!isEditing" :default="false" :clearable="true" type="datetime" />
          </v-col>

          <v-col cols="12" md="4">
            <v-select
              v-model="item.allowed_billing_cycles"
              :items="billingCycleItems"
              label="بازه قابل استفاده"
              clearable
              :disabled="!isEditing"
              outlined
              dense
              multiple
              chips
              small-chips
              deletable-chips
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-select
              v-model="item.allowed_packages"
              :items="packageItems"
              label="بسته های قابل استفاده"
              :disabled="!isEditing"
              clearable
              outlined
              dense
              multiple
              chips
              small-chips
              deletable-chips
            />
          </v-col>

          <v-col cols="12">
            <v-switch label="فعال" v-model="item.is_active" :disabled="!isEditing" />
          </v-col>
        </v-row>
      </template>
    </m-form>
  </div>
</template>
<script>
import { MFormMixin } from "@/components/m-form";

export default {
  mixins: [MFormMixin],
  data() {
    return {
      baseUrl: "sobhanAdmin/discountCodes",
      appendSlash: true,
      hasList: false,
      hasIdProp: true,
      packageItems: [
        { text: "پایه", value: "TWO" },
        { text: "هوشمند", value: "THREE" },
        { text: "قدرتمند", value: "FOUR" },
        { text: "حقوق و دستمزد", value: "PAYROLL" },
      ],
      billingCycleItems: [
        { text: "ماهانه", value: "monthly" },
        { text: "سالانه", value: "yearly" },
        { text: "شش ماهه", value: "six_monthly" },
        { text: "دائمی", value: "permanent" },
      ],
    };
  },
  methods: {
    getItemTemplate() {
      return {
        is_active: true,
      };
    },
  },
};
</script>
